/**
 * @file PhonePanelBar.tsx
 * @description Нижняя полоса панели на весь экран в конструкторе на
 * телефоне (phase19.16 Р1-6а; uiux-builder-shell.md §2.3): [Смотреть на
 * сайте] — та же панель шторкой над сайтом, и главное действие
 * конструктора («Опубликовать» / «Обновить страницу на сайте»). Почему
 * главное действие неактивно — подписью над кнопками.
 */

import { Eye } from "lucide-react";

import { Button } from "../../ui/button";
import { useBuilderMainAction } from "./useBuilderMainAction";
import { shortActionLabel } from "../../../lib/site-builder/publish-rules";

export function PhonePanelBar({ onView }: { onView: () => void }) {
  const main = useBuilderMainAction();
  const reason = main.action.kind === "disabled" ? main.action.reason : null;
  return (
    <div className="flex shrink-0 flex-col gap-2 pt-3 [box-shadow:inset_0_1px_0_var(--outline-variant)]">
      {reason ? <p className="type-caption text-center text-on-surface-variant">{reason}</p> : null}
      <div className="grid grid-cols-2 gap-2">
        <Button variant="outline" className="h-12" onClick={onView}>
          <Eye aria-hidden />
          Смотреть
        </Button>
        <Button variant="brand" className="h-12 min-w-0" disabled={main.action.kind === "disabled"} loading={main.busy} onClick={main.run}>
          <span className="truncate">{shortActionLabel(main.action.label)}</span>
        </Button>
      </div>
    </div>
  );
}
